<template>
  <a-tree-select
    v-model="dept"
    class="dept-select"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    :tree-data="deptList"
    placeholder="选择部门"
  >
    <template v-slot:title="{ value }">
      <open-data :openid="value" type="departmentName" />
    </template>
  </a-tree-select>
</template>

<script>
export default {
  name: "DeptSelect",
  props: {
    value: {
      type: Number,
    },
    deptList: {
      type: Array,
    },
  },
  computed: {
    dept: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  }
};
</script>

<style lang="less" scoped>
.dept-select.ant-select {
  width: 414px;
  color: var(--primary-color);
  :deep(.ant-select-selection) {
    border-color: var(--primary-color);
    background-color: rgba(255, 255, 255, 0.1);
    .ant-select-arrow {
      color: var(--primary-color);
    }
  }
}
</style>
